"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = Select;

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _select = require("../../select");

var _fieldAlert = require("../field-alert");

var _fieldError = require("../field-error");

var _fieldsStyledComponents = require("../fields-styled-components");

var _reactForms = require("@seegno/react-forms");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["className", "closeMenuOnSelect", "disabled", "helpText", "hideSelectedOptions", "id", "isClearable", "isMulti", "label", "name", "onChange", "options"],
    _excluded2 = ["error", "meta", "onChange", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * `StyledFormControlWrapper` styled component.
 */
var StyledFormControlWrapper = (0, _styledComponents["default"])(_fieldsStyledComponents.FormControlWrapper).withConfig({
  displayName: "select__StyledFormControlWrapper",
  componentId: "sc-7c7yen-0"
})(["column-gap:initial;display:block;"]);
/**
 * Export `Select` component.
 */

function Select(props) {
  var className = props.className,
      _props$closeMenuOnSel = props.closeMenuOnSelect,
      closeMenuOnSelect = _props$closeMenuOnSel === void 0 ? true : _props$closeMenuOnSel,
      disabled = props.disabled,
      helpText = props.helpText,
      _props$hideSelectedOp = props.hideSelectedOptions,
      hideSelectedOptions = _props$hideSelectedOp === void 0 ? false : _props$hideSelectedOp,
      id = props.id,
      _props$isClearable = props.isClearable,
      isClearable = _props$isClearable === void 0 ? true : _props$isClearable,
      _props$isMulti = props.isMulti,
      isMulti = _props$isMulti === void 0 ? false : _props$isMulti,
      label = props.label,
      name = props.name,
      onChange = props.onChange,
      options = props.options,
      rest = _objectWithoutProperties(props, _excluded);

  var _useField = (0, _reactForms.useField)(name),
      error = _useField.error,
      meta = _useField.meta,
      onFieldChange = _useField.onChange,
      value = _useField.value,
      fieldProps = _objectWithoutProperties(_useField, _excluded2);

  var _ref = meta || {},
      isActive = _ref.active;

  var _useFormState = (0, _reactForms.useFormState)(),
      alreadySubmitted = _useFormState.alreadySubmitted,
      isSubmitting = _useFormState.isSubmitting;

  var hasError = !!error && alreadySubmitted;
  var isDisabled = disabled || isSubmitting;
  var handleChange = (0, _react.useCallback)(function (value) {
    if (onChange) {
      onChange(value);
    }

    onFieldChange(value);
  }, [onChange, onFieldChange]);
  return /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.FormGroup, {
    className: className,
    disabled: isDisabled
  }, /*#__PURE__*/_react["default"].createElement(StyledFormControlWrapper, {
    disabled: isDisabled,
    hasAlert: hasError || !!helpText,
    hasError: hasError,
    hasFocus: isActive
  }, /*#__PURE__*/_react["default"].createElement(_fieldsStyledComponents.Label, {
    disabled: isDisabled,
    htmlFor: id !== null && id !== void 0 ? id : name,
    id: "".concat(name, "_label"),
    isFloating: !(0, _isNil2["default"])(value) || isActive
  }, label), /*#__PURE__*/_react["default"].createElement(_select.BaseSelect, _extends({
    "aria-describedby": helpText ? "".concat(name, "Description") : null,
    closeMenuOnSelect: closeMenuOnSelect,
    disabled: isDisabled,
    hasValues: !(0, _isNil2["default"])(value),
    hideSelectedOptions: hideSelectedOptions,
    id: id !== null && id !== void 0 ? id : name,
    isClearable: isClearable,
    isMulti: isMulti,
    name: name,
    onChange: handleChange,
    options: options,
    value: value
  }, rest, fieldProps))), helpText && /*#__PURE__*/_react["default"].createElement(_fieldAlert.FieldAlert, {
    isOpen: !hasError
  }, helpText), /*#__PURE__*/_react["default"].createElement(_fieldError.FieldError, {
    error: error,
    isOpen: hasError,
    name: name
  }));
}